import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../store/useAuthStore";
import { isInventoryStockOnlyUser } from "../utils/permissions";

/**
 * Blocks permission-400 users from pages outside Inventory / Stock Upload.
 * Sends them to the full-page /404 (no sidebar/layout).
 */
const BlockRestrictedUser = ({ children }) => {
  const { user, isAuthenticated } = useAuthStore();
  const hasStoredSession = !!localStorage.getItem("user");

  if (!isAuthenticated && !hasStoredSession) {
    return <Navigate to="/login" replace />;
  }

  if (!isAuthenticated || !user) {
    return null;
  }

  if (isInventoryStockOnlyUser(user)) {
    return <Navigate to="/404" replace />;
  }

  return children;
};

export default BlockRestrictedUser;
